module.exports = __webpack_public_path__ + "images/category_lp/art_work/store_images/3_742a99b13cf74f9868edeaf862a1f9eb.png";